import React from 'react';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import StepWizard from 'react-step-wizard';
import Step from '../../Shared/UI/Step/components/Step';
import InvitationRequestForm from './InvitationRequestForm';
import InvitationRequestReceived from './InvitationRequestReceived';

import styles from './InvitationRequestWizard.module.scss';

const InvitationRequestWizard = ({
  showInvitationRequestWizard,
  closeInvitationRequestWizard
}) => {
  return (
    <StandardModal
      isOpen={showInvitationRequestWizard}
      className={styles.modal}
      overlayClassName={styles.overlay}
      contentLabel="Invitation Request Wizard"
      onRequestClose={closeInvitationRequestWizard}
    >
      <StepWizard>
        <Step>
          <InvitationRequestForm
            closeInvitationRequestWizard={closeInvitationRequestWizard}
          />
        </Step>
        <Step>
          <InvitationRequestReceived
            closeInvitationRequestWizard={closeInvitationRequestWizard}
          />
        </Step>
      </StepWizard>
    </StandardModal>
  );
};

export default InvitationRequestWizard;
